import classNames from 'classnames';
import React, { FC } from 'react';
import { Typography } from '../Typography';
import styles from './PropertyPrice.module.scss';

export type PropertyPriceProps = {
	amount: string | React.ReactElement;
	additional?: string;
	className?: string;
};

export const PropertyPrice: FC<PropertyPriceProps> = ({ amount, additional, className }) => {
	return (
		<Typography as="p" className={classNames(styles.propertyPrice, 'propertyPrice mb-0', className)}>
			<span>{amount}</span>
			{additional && <span className={styles.propertyPriceAdditional}>{additional}</span>}
		</Typography>
	);
};
